import { useContext } from "react";
import { useMediaQuery } from "@mui/material";

import styles from "./WhoIsRight.module.css";

import boy1 from "../assets/per.svg";
import boy2 from "../assets/boy2.svg";
import girl1 from "../assets/maja.svg";
import girl2 from "../assets/girl2.svg";
import StyledButton from "../components/StyledButton";
import { LangContext } from "../contexts/langContext";
import { SelectAnswerContext } from "../contexts/selectAnswerContext";
import { getButtonPalletFromCorrectOrIncorrect } from "../util/getButtonPalletFromCorrectOrIncorrect";
import useShowingCorrectAnswer from "../hooks/useShowingCorrectAnswer";
import { WhoIsRightRenderProps } from "@common";
import useTranslatePageText from "@natklok/hooks/useTranslatePageText";

interface RenderProps extends WhoIsRightRenderProps {
  readOnly?: boolean;
  showCorrect?: boolean;
}

const getImageSrcFromImgName = (str: string): string => {
  switch (str) {
    case "boy1":
      return boy1;
    case "boy2":
      return boy2;
    case "girl1":
      return girl1;
    case "girl2":
      return girl2;
    default:
      return boy1;
  }
};

const WhoIsRight: React.FC<{
  [key in keyof RenderProps]: RenderProps[key];
}> = ({
  person1Name,
  person1ImageSrcName,
  person1Text,
  person1IsCorrect,
  person2Name,
  person2ImageSrcName,
  person2Text,
  person2IsCorrect,
  readOnly = false,
  showCorrect = false,
}) => {
  const { translateTranslationData, translatePageText } = useContext(LangContext);
  const { onSelectAnswer } = useContext(SelectAnswerContext);
  const isSmallDevice = useMediaQuery("(max-width:530px)");
  const showingCorrectAnswer = useShowingCorrectAnswer();
  const displayCorrectAnswers = showCorrect || showingCorrectAnswer;

  return (
    <>
      <div className={styles.container}>
        <div className={styles.leftAligned}>
          <div className={styles.questionCloud}>
            <div>{translateTranslationData(person1Text)}</div>
          </div>
          <div className={styles.emoji}>
            <div>
              <img src={getImageSrcFromImgName(person1ImageSrcName)} alt={person1Name} />
              <p style={{ textAlign: "center", margin: 0 }}>{person1Name}</p>
            </div>
          </div>
        </div>
        <div>
          <div className={styles.questionCloud}>
            <div>{translateTranslationData(person2Text)}</div>
          </div>
          <div className={styles.emoji}>
            <div>
              <img src={getImageSrcFromImgName(person2ImageSrcName)} alt={person2Name} />
              <p style={{ textAlign: "center", margin: 0 }}>{person2Name}</p>
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "16px",
          width: "100%",
        }}
      >
        <StyledButton
          hasCooldown
          disabled={readOnly}
          onClick={() =>
            onSelectAnswer(person1IsCorrect, {
              val1: 0,
              val2: person1IsCorrect === "correct" ? 1 : 0,
              val3: person1IsCorrect === "incorrect" ? 1 : 0,
            })
          }
          fullWidth
          style={{
            maxWidth: "13em",
            margin: 0,
          }}
          label={
            isSmallDevice
              ? person1Name
              : person1Name + " " + translatePageText("test.isThinkingRight")
          }
          clickable={displayCorrectAnswers === false}
          palette={getButtonPalletFromCorrectOrIncorrect(displayCorrectAnswers, person1IsCorrect)}
        />
        <StyledButton
          hasCooldown
          disabled={readOnly}
          onClick={() =>
            onSelectAnswer(person2IsCorrect, {
              val1: 0,
              val2: person2IsCorrect === "correct" ? 1 : 0,
              val3: person2IsCorrect === "incorrect" ? 1 : 0,
            })
          }
          fullWidth
          style={{
            maxWidth: "13em",
            margin: 0,
          }}
          label={
            isSmallDevice
              ? person2Name
              : person2Name + " " + translatePageText("test.isThinkingRight")
          }
          clickable={displayCorrectAnswers === false}
          palette={getButtonPalletFromCorrectOrIncorrect(displayCorrectAnswers, person2IsCorrect)}
        />
      </div>
    </>
  );
};

export default WhoIsRight;
